<template>
  <div class="legend">
    <ul>
      <li
        v-for="(item, index) in legend"
        v-bind:key="index"
        @click="toggleLayerSelect(item)"
        v-bind:class="{ active: item.selected }"
      >
        <span
          class="color selected"
          v-bind:style="{ backgroundColor: item.color.fill }"
        ></span>
        <span v-bind:style="{ color: item.color.fill }">{{ item.type=='宗教寺庙'?"名刹古寺":item.type }}</span>
      </li>
    </ul> 
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  components: {},
  computed: {
    legend() {
      return this.$store.state.legend;
    }, 
  },
  methods: {
    toggleLayerSelect(layer) {
      layer.selected = !layer.selected;
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.legend {
  position: absolute;
  bottom: 60px;
  right: 0;
  width: 124px;
  padding: 16px 20px;
  background: #ffffff;
  ul {
    list-style-type: none;
    padding-inline-start: 0px;
    li {
      line-height: 25px;
      display: inline-block;
      width: 100%;
      padding-right: 5px;
      opacity: 0.5;
      .color {
        width: 15px;
        padding: 0px;
        height: 15px;
        border-radius: 20px;
        border: solid 1px #ccc;
        vertical-align: middle;
        display: inline-block;
        margin-right: 5px;
        margin-top: -2px;
      }
      .label {
        display: inline-block;
      }
    }
    li:hover {
      cursor: pointer;
      opacity: 1;
    }
    li.active {
      cursor: pointer;
      opacity: 1;
      .color {
        border: solid 1px rgb(17, 17, 17);
      }
    }
    li::nth-child(4):before {
      content: "<hr>";
      display: block;
      width: 100%;
    }
  }
}
</style>
